import React, { useEffect, useState } from 'react';
import { supabase } from '../../utils/supabaseClient';
import { Trophy, Star } from 'lucide-react';
import { AvatarDisplay } from '../../utils/avatars';
import { useNavigate } from 'react-router-dom';

export default function ActiveOrganizersBoard() {
  const [organizers, setOrganizers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchTopOrganizers() {
      const { data, error } = await supabase
        .from('profiles')
        .select('id, name, avatar, total_points')
        .gt('total_points', 0)
        .order('total_points', { ascending: false })
        .limit(3);
      
      if (data && !error) {
        setOrganizers(data);
      }
    }
    fetchTopOrganizers();
  }, []);

  if (organizers.length === 0) return null;

  return (
    <div style={{
      background: '#ffffff',
      border: '1px solid #e2e8f0',
      borderRadius: '20px',
      padding: '20px',
      boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)',
      marginBottom: '24px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
        <Trophy size={20} color="#eab308" />
        <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '800', color: '#0f172a' }}>本週活躍主揪</h3>
      </div>
      
      <div style={{ display: 'flex', gap: '16px', overflowX: 'auto', paddingBottom: '8px', msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
        {organizers.map((user, index) => (
          <div 
            key={user.id} 
            onClick={() => navigate(`/user/${user.id}`)}
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '12px', 
              background: '#f8fafc', 
              padding: '12px', 
              borderRadius: '16px', 
              minWidth: '160px',
              cursor: 'pointer' 
            }}
          >
            <div style={{ position: 'relative' }}>
              <div style={{ width: '44px', height: '44px', borderRadius: '50%', overflow: 'hidden' }}>
                <AvatarDisplay avatarId={user.avatar} size={44} />
              </div>
              <div style={{ position: 'absolute', bottom: '-4px', right: '-4px', background: '#eab308', color: 'white', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: 'bold', border: '2px solid white' }}>
                {index + 1}
              </div>
            </div>
            <div>
              <div style={{ fontSize: '14px', fontWeight: '700', color: '#0f172a', marginBottom: '4px', maxWidth: '80px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {user.name}
              </div>
              <div style={{ fontSize: '12px', color: '#64748b', display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Star size={12} color="#fbbf24" fill="#fbbf24" /> {user.total_points} 分
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
